export default "__VITE_ASSET__620b9c91__"